import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import { Card, CardContent } from '../components/ui/Card';
export function ViewSectionQuestion() {
  const navigate = useNavigate();
  return <div className="space-y-4" data-id="element-2681" data-mp="37mmisep8txij">
      <div className="flex items-center justify-between" data-id="element-2682" data-mp="32o1pz0cbmg44">
        <h1 className="text-2xl font-bold text-slate-900" data-id="element-2683" data-mp="32oky5pc65q4y">Section Question</h1>
        <Button variant="secondary" size="sm" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" onClick={() => navigate('/questions')} data-id="element-2684" data-mp="2ezij8p8x6be5">
          ← Back to Questions
        </Button>
      </div>

      <Card data-id="element-2685" data-mp="2jxabxlhe21je">
        <CardContent className="pt-6" data-id="element-2686" data-mp="2jws5jw10i6xr">
          <table className="text-sm w-full" data-id="element-2687" data-mp="2jvqq7fcyqya8">
            <tbody data-id="element-2688" data-mp="1w6xt3fkluke1">
              <tr className="border-b border-slate-100" data-id="element-2689" data-mp="1w6en8x88bmgd">
                <td className="py-2 pr-6 font-medium text-slate-700 w-32 align-top" data-id="element-2690" data-mp="1r9eeufnwq7m3">
                  Id
                </td>
                <td className="py-2 text-slate-900" data-id="element-2691" data-mp="2ps4fi2649ne6">101</td>
              </tr>
              <tr className="border-b border-slate-100" data-id="element-2692" data-mp="2ur7a0soh0b7w">
                <td className="py-2 pr-6 font-medium text-slate-700 align-top" data-id="element-2693" data-mp="2upw9d1qbnjl0">
                  Course
                </td>
                <td className="py-2 text-slate-900" data-id="element-2694" data-mp="33k2hlt1euj0u">Desert Ecology Basics</td>
              </tr>
              <tr className="border-b border-slate-100" data-id="element-2695" data-mp="26ubb0vfuh5eo">
                <td className="py-2 pr-6 font-medium text-slate-700 align-top" data-id="element-2696" data-mp="26vw7wrpmt0fp">
                  Section
                </td>
                <td className="py-2 text-slate-900" data-id="element-2697" data-mp="2fupzg3o3v0me">Section 1</td>
              </tr>
              <tr className="border-b border-slate-100" data-id="element-2698" data-mp="2fwuffjza3q31">
                <td className="py-2 pr-6 font-medium text-slate-700 align-top" data-id="element-2699" data-mp="2kuvu7spo938p">
                  Question
                </td>
                <td className="py-2 text-slate-900 leading-relaxed" data-id="element-2700" data-mp="3r9n2wil1dsda">
                  What is the primary water source for desert flora?
                </td>
              </tr>
              <tr className="border-b border-slate-100" data-id="element-2701" data-mp="1w5fafbfvph3p">
                <td className="py-2 pr-6 font-medium text-slate-700" data-id="element-2702" data-mp="1s5ewrt0lt9xp">Answer</td>
                <td className="py-2 text-slate-900 capitalize" data-id="element-2703" data-mp="1s7hk25adgoyq">yes</td>
              </tr>
              <tr className="border-b border-slate-100" data-id="element-2704" data-mp="262tq38tza1uy">
                <td className="py-2 pr-6 font-medium text-slate-700" data-id="element-2705" data-mp="216uvv4lyxpmm">
                  Created
                </td>
                <td className="py-2 text-slate-900" data-id="element-2706" data-mp="1dh0h2hi39qzq">2023-01-15</td>
              </tr>
              <tr data-id="element-2707" data-mp="18i73kp2sxzzk">
                <td className="py-2 pr-6 font-medium text-slate-700" data-id="element-2708" data-mp="18iqq6j3edcjx">
                  Modified
                </td>
                <td className="py-2 text-slate-900" data-id="element-2709" data-mp="1n850btesry0d">2023-06-20</td>
              </tr>
            </tbody>
          </table>
        </CardContent>
      </Card>
    </div>;
}